import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isTokenValid, getRoleFromToken, clearAuthToken } from '../utils/tokenValidation';
import { getTokenForPath } from '../utils/authToken';
import { satisfaceRol, rutaPorDefecto, type Rol } from './roleAccess';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiresAuth?: boolean;
  requiredRole?: Rol;
}

export function ProtectedRoute({ 
  children, 
  requiresAuth = false, 
  requiredRole 
}: ProtectedRouteProps) {
  const location = useLocation();
  const token = getTokenForPath(location.pathname);

  // 1. Chequeo de Autenticación
  if (requiresAuth && !token) {
    return React.createElement(Navigate, { to: '/', replace: true, state: { from: location } });
  }

  // 1.5. Validar que el token no esté expirado
  if (token && !isTokenValid(token)) {
    clearAuthToken(false);
    return React.createElement(Navigate, { to: '/', replace: true, state: { from: location } });
  }

  // 2. NO redirigir automáticamente desde / - permitir que el usuario siempre vea el login
  // Esta lógica se maneja en HomeRoute para dar más control

  // 3. Chequeo de Autorización por Rol
  if (token && requiredRole) {
    const userRole = getRoleFromToken(token);

    if (!userRole) {
      clearAuthToken(false);
      return React.createElement(Navigate, { to: '/', replace: true });
    }

    // La comparación no es de igualdad: admin incluye reclutador, igual que en
    // el backend. Ver roleAccess.ts.
    if (!satisfaceRol(userRole, requiredRole)) {
      return React.createElement(Navigate, { to: rutaPorDefecto(userRole), replace: true });
    }
  }

  return React.createElement(React.Fragment, null, children);
}
